import './application.css'
import axios from 'axios'
import { createInertiaApp, router } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { useEffect, useState } from 'react'
import { LocaleProvider } from '../lib/LocaleContext'
import { installCsrfHeader } from '../lib/csrf'

// DECISION-7: Install the Rails CSRF token as an axios default header BEFORE
// createInertiaApp so Inertia's transport layer (which delegates to axios)
// carries X-CSRF-Token on every request without per-call headers in each page.
installCsrfHeader(document, axios)

createInertiaApp({
  resolve: name => {
    const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })
    return pages[`../pages/${name}.jsx`]
  },
  setup({ el, App, props }) {
    function Root() {
      const [locale, setLocale] = useState(
        props.initialPage?.props?.locale ?? 'en'
      )

      useEffect(() => {
        return router.on('navigate', event => {
          const newLocale = event.detail.page.props?.locale ?? 'en'
          setLocale(newLocale)
        })
      }, [])

      return (
        <LocaleProvider locale={locale}>
          <App {...props} />
        </LocaleProvider>
      )
    }

    createRoot(el).render(<Root />)
  },
})
